import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../../components/layout/AdminLayout";
import { Helmet } from "react-helmet-async";
import EditCourseList from "../../components/intersession/EditCoursesList";
import * as FaIcons from "react-icons/fa";
import UserContext from "../../context/users/userContext";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

const EditCoursesPage = () => {
  const navigate = useNavigate();
  const { name, id, permalink } = useParams();
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const {
    getSearchSites, searchSites = []
  } = adminRegistrationContext;

//   const userContext = useContext(UserContext);
//   const { user, getUser, users, getUsers } = userContext;

  useEffect(() => {
    getSearchSites();
  }, []);

  const sortedCourses =
    searchSites.length > 0
      ? searchSites.sort((a, b) => {
          if (a.charter < b.charter) return -1;
          if (a.charter > b.charter) return 1;
          return 0;
        })
      : [];

  return (
    <AdminLayout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Edit Courses</title>
      </Helmet>
      <section id="interest-form-list-page">
        <div
          className="container"
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            className="top-bar"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              position: "relative",
            }}
          >
            <div
              onClick={() => {
                navigate("/intersession");
              }}
              className="go-back-button"
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                position: "absolute",
                left: "20px",
                color: "#537131",
              }}
            >
              <FaIcons.FaArrowLeft className="menu-icon" />
              <span style={{ fontSize: "18px" }}>Go Back</span>
            </div>
            <h2 className="text-center top-title">{name}</h2>
          </div>
          <EditCourseList items={sortedCourses} courseid={id} permalink={permalink} />

        </div>
      </section>
    </AdminLayout>
  );
};

export default EditCoursesPage;
